module.exports = __webpack_public_path__ + "static/media/oracledb.d62b58b0.svg";